<template>
    <div class="grid grid-cols-1 row-gap-2 col-gap-4 sm:grid-cols-12 pt-4 pb-6">
        <input-textarea class="sm:col-span-12"
            placeholder="Enter Note Content"
            name="note"
            v-model="note"
            :required="false" />
        <div class="sm:col-span-12">
            <button type="button" class="bg-default-500 hover:bg-default-600 disabled:opacity-50 text-white px-4 py-2 text-sm border-0"
                @click="save()"
                :disabled="!note">
                Add Note
            </button>
        </div>
        <h2 class="w-full sm:col-span-12 py-2 border-b-2 border-charcoal-900 text-left font-medium text-charcoal-900" v-show="notes.length > 0">Notes</h2>
        <div class="pt-2 sm:col-span-12" :class="{ 'max-h-110 overflow-y-auto small-scrollbar': scroll }" id="notes">
            <div class="w-full flex flex-wrap relative" v-for="(item, index) in notes" :key="index">
                <div class="absolute border-2 rounded-full border-gray-400 w-12 h-12 flex justify-center items-center bg-white z-10">
                    <font-awesome-icon class="text-gray-700 text-lg" :icon="['fal', 'sticky-note']"/>
                </div>
                <div class="ml-6 pl-10 flex-grow w-full border-l-2 border-gray-400 text-xs pb-4 note-container relative group">
                    <div class="bg-white py-2 px-4" v-html="item.note.replace(/(?:\r\n|\r|\n)/g, '<br>')" v-if="selectedItem.id !== item.id"></div>
                    <input-textarea class="sm:col-span-12"
                        name="note"
                        v-model="selectedItem.note"
                        :required="false"
                        v-if="selectedItem.id === item.id"
                        rows="3"
                        @save="save"/>
                    <button type="button" class="bg-default-500 hover:bg-default-600 text-white px-2 py-1 text-xs border-0 mt-1"
                        @click="save()"
                        v-if="selectedItem.id === item.id">
                        Save
                    </button>
                    <button type="button" class="bg-gray-500 hover:bg-gray-600 text-white px-2 py-1 text-xs border-0 mt-1 ml-1"
                        @click="selectedItem = {}"
                        v-if="selectedItem.id === item.id">
                        Cancel
                    </button>
                    <div class="text-xs text-gray-800 pl-4 mt-1" style="font-size: 0.8em;" v-if="selectedItem.id !== item.id">{{ item.meta.created_by ? item.meta.created_by.full_name : 'N/A' }} - <span v-tooltip="item.meta.updated_at_human" class="cursor-pointer">{{ localDateTime(item.meta.updated_at) }}</span></div>
                    <div class="absolute right-0 top-0 mt-2 mr-2 hidden group-hover:block" v-if="selectedItem.id !== item.id">
                        <button type="button" class="bg-gray-100 px-1 border border-gray-400 hover:bg-gray-300 mr-1" @click="edit(item, index)">
                            <font-awesome-icon class="text-gray-700" style="font-size: 1em;" :icon="['fal', 'pencil-alt']" />
                        </button>
                        <button type="button" class="bg-gray-100 px-1 border border-gray-400 hover:bg-gray-300 mx-1" @click="reply(item, index)">
                            <font-awesome-icon class="text-gray-700" style="font-size: 1em;" :icon="['fal', 'reply']" />
                        </button>
                        <button type="button" class="bg-gray-100 px-1 border border-gray-400 hover:bg-gray-300 ml-1" @click="destroy(item, index)" >
                            <font-awesome-icon class="text-red-700" style="font-size: 1em;" :icon="['fal', 'trash-alt']" />
                        </button>
                    </div>
                </div>
                <!-- reply notes -->
                <div class="w-full flex flex-wrap" v-if="item.replies">
                    <div class="ml-14 pl-12 flex-grow w-full border-l-2 border-gray-400 text-xs pb-2 note-container relative group" v-for="(rItem, rIndex) in item.replies" :key="rIndex">
                        <div class="bg-white py-2 px-4" v-html="rItem.note.replace(/(?:\r\n|\r|\n)/g, '<br>')" v-if="selectedItem.id !== rItem.id"></div>
                        <input-textarea class="sm:col-span-12"
                            name="note"
                            v-model="selectedItem.note"
                            :required="false"
                            v-if="selectedItem.id === rItem.id"
                            rows="3"
                            @save="save"/>
                        <button type="button" class="bg-default-500 hover:bg-default-600 text-white px-2 py-1 text-xs border-0 mt-1"
                            @click="save()"
                            v-if="selectedItem.id === rItem.id">
                            Save
                        </button>
                        <button type="button" class="bg-gray-500 hover:bg-gray-600 text-white px-2 py-1 text-xs border-0 mt-1 ml-1"
                            @click="selectedItem = {}"
                            v-if="selectedItem.id === rItem.id">
                            Cancel
                        </button>
                        <div class="text-xs text-gray-800 pl-4 mt-1" style="font-size: 0.8em;" v-if="selectedItem.id !== rItem.id">{{ rItem.meta.created_by ? rItem.meta.created_by.full_name : 'N/A' }} - <span v-tooltip="rItem.meta.updated_at_human" class="cursor-pointer">{{ localDateTime(rItem.meta.updated_at) }}</span></div>
                        <div class="absolute right-0 top-0 mt-2 mr-2 hidden group-hover:block" v-if="selectedItem.id !== rItem.id">
                            <button type="button" class="bg-gray-100 px-1 border border-gray-400 hover:bg-gray-300 mr-1" @click="edit(rItem, index, rIndex)">
                                <font-awesome-icon class="text-gray-700" style="font-size: 1em;" :icon="['fal', 'pencil-alt']" />
                            </button>
                            <button type="button" class="bg-gray-100 px-1 border border-gray-400 hover:bg-gray-300 mx-1" @click="reply(item, index)">
                                <font-awesome-icon class="text-gray-700" style="font-size: 1em;" :icon="['fal', 'reply']" />
                            </button>
                            <button type="button" class="bg-gray-100 px-1 border border-gray-400 hover:bg-gray-300 ml-1" @click="destroy(rItem, index, rIndex)" >
                                <font-awesome-icon class="text-red-700" style="font-size: 1em;" :icon="['fal', 'trash-alt']" />
                            </button>
                        </div>
                    </div>
                </div>
                <!-- replying controls -->
                <div class="w-full flex flex-wrap" v-if="selectedItem.parent_id == item.id && !replyIndex">
                    <div class="ml-14 pl-12 flex-grow w-full border-l-2 border-gray-400 text-xs pb-2 note-container relative group">
                        <input-textarea class="sm:col-span-12"
                            name="note"
                            v-model="selectedItem.note"
                            :required="false"
                            rows="2"
                            @save="save"/>
                        <button type="button" class="bg-default-500 hover:bg-default-600 text-white px-2 py-1 text-xs border-0 mt-1"
                            @click="save()">
                            Save
                        </button>
                        <button type="button" class="bg-gray-500 hover:bg-gray-600 text-white px-2 py-1 text-xs border-0 mt-1 ml-1"
                            @click="selectedItem = {}">
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from "axios";
    import moment from "moment";

    export default {
        name: "Notes",
        props: {
            notes: { type: Array, default: () => [], required: false },
            model: { type: String, required: true },
            id: { required: true },
            scroll: { default: false }
        },
        data: function () {
            return {
                note: '',
                selectedItem: {},
                selectedIndex: null,
                replyIndex: null,
            }
        },
        methods: {
            localDateTime(dt){
                return moment(dt).format('DD/MM/YYYY h:mm a');
            },
            edit(item, index, rindex=null){
                this.selectedIndex = index;
                this.selectedItem = item;
                this.replyIndex = rindex;
            },
            reply(item, index){
                this.replyIndex = null;
                this.selectedItem = {};
                this.selectedItem.parent_id = item.id;
                this.selectedIndex = index;
            },
            save(){
                let _method;
                let _url;
                let _type = 'Add';
                this.$store.commit('TOGGLE_BACKDROP', {open: true});

                if (this.selectedItem.id) {
                    _type = 'Edit';
                    _url = process.env.VUE_APP_API_URL + '/notes/' + this.selectedItem.id;
                    _method = 'PUT';
                } else {
                    _url = process.env.VUE_APP_API_URL + '/notes';
                    _method = 'POST';
                }

                axios({
                    method: _method,
                    url: _url,
                    data: {
                        note: this.selectedItem.note ? this.selectedItem.note : this.note,
                        parent_id: this.selectedItem.parent_id ? this.selectedItem.parent_id : null,
                        model: this.model,
                        id: this.id
                    }
                }).then(response => {
                    if (response.data.success){

                        // no parent_id - dealing with notes
                        if (!this.selectedItem.parent_id){

                            if (_type === 'Add') {
                                this.notes.unshift(response.data.data);
                            } else if (_type === 'Edit'){
                                this.notes[this.selectedIndex] = response.data.data;
                            }

                        } else {
                        // parent_id - dealing with replies

                            // initialise the replies object if needed
                            if (!this.notes[this.selectedIndex].replies){
                                this.notes[this.selectedIndex].replies = [];
                            }

                            if (_type === 'Add') {
                                this.notes[this.selectedIndex].replies.push(response.data.data)
                            } else if (_type === 'Edit'){
                                this.notes[this.selectedIndex].replies[this.replyIndex] = response.data.data;
                            }

                        }

                        this.$notify({
                            group: 'main',
                            position: 'bottom right',
                            type: 'success',
                            title: 'Success',
                            text: response.data.message,
                            duration: 5000
                        });

                        // reset local vars
                        this.note = '';
                        this.selectedItem = {};
                        this.selectedIndex = null;
                        this.replyIndex = null;

                    } else {
                        this.$notify({
                            group: 'main',
                            position: 'bottom right',
                            type: 'error',
                            title: 'Error',
                            text: response.data.message,
                            duration: 5000
                        });
                    }

                    this.$store.commit('TOGGLE_BACKDROP', {open: false});
                }).catch((error) => {
                    this.$store.commit('TOGGLE_BACKDROP', {open: false});

                    this.$notify({
                        group: 'main',
                        position: 'bottom right',
                        type: 'error',
                        title: 'Error',
                        text: error.message,
                        duration: 5000
                    });
                });
            },
            destroy(item, index, rindex=null){
                this.$store.commit('TOGGLE_BACKDROP', {open: true});

                axios.delete(process.env.VUE_APP_API_URL + '/notes/'+item.id, {
                    params: {
                        model: this.model,
                        id: this.id
                    }
                }).then(response => {
                    let message;

                    if (response.data.success){

                        if(!rindex){
                            this.notes.splice(index, 1);
                        }else{
                            this.notes[index].replies.splice(rindex, 1);
                        }

                        this.$store.commit('TOGGLE_BACKDROP', {open: false});

                        if (response.data.message){
                            message = response.data.message;
                        } else {
                            message = 'Successfully Deleted Note!';
                        }

                        this.$notify({
                            group: 'main',
                            position: 'top center',
                            type: 'success',
                            title: 'Success',
                            text: message,
                            duration: 10000,
                            speed: 1000
                        });
                    }
                }).catch((error) => {
                    this.$store.commit('TOGGLE_BACKDROP', {open: false});

                    this.$notify({
                        group: 'main',
                        position: 'bottom right',
                        type: 'error',
                        title: 'Error',
                        text: error.message,
                        duration: 5000
                    });
                });
            }
        }
    }
</script>

<style scoped>
    #notes div:last-child .note-container {
        border: 0!important;
    }
</style>
